import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { Section } from '../section'
import { styles } from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'

export const AboutSection: React.FC = () => {
  return (
    <Section id="about" title="ABOUT" subtitle="私たち、FLOWERについて" className={styles.section}>
      <Flex direction="column" align="center" justify="start" width="100%" gap="24px" px="24px">
        <div className={styles.images}>
          <img className={styles.image} src={image4} style={{ animationDelay: '9s' }} />
          <img className={styles.image} src={image3} style={{ animationDelay: '6s' }} />
          <img className={styles.image} src={image2} style={{ animationDelay: '3s' }} />
          <img className={styles.image} src={image1} style={{ animationDelay: '0s' }} />
        </div>
        <Flex direction="column" align="center" justify="start" width="100%" gap="8px">
          <h3 className={styles.heading}>ロスがないから毎日お得<br />アプリのお花屋さん</h3>
          <p className={styles.text}>
            お花のロス（廃棄）を生み出さない独自の仕組みにより、手頃な価格を実現。これまで100万束以上のブーケをお届けしてきました。
            公式Instagramは毎日更新！ぜひこちらもチェックしてみてください☺️
          </p>
        </Flex>
        <a className={styles.button} href="https://www.instagram.com/flowr_is/" target="_blank">
          FLOWER公式Instagram
        </a>
      </Flex>
    </Section>
  )
}
